import { Injectable } from '@angular/core';
import { BzgToastService, BzgToastType } from 'bz-genome-angular';

@Injectable({
    providedIn: 'root'
})
export class ShowToastService {

    constructor(private _toastService: BzgToastService) { }

    /**
     * Shows a toast notification with the specified message and type
     * @param message - The message to display in the toast
     * @param type - The type of toast ('success', 'error', 'warning', 'info')
     */
    showToast(message: string, type: BzgToastType): void {
        this._toastService.open(
            message,
            {
                type,
                duration: type === 'error' ? 0 : (type === 'warning' ? 10000 : 8000), // 0 = eternal for errors, 10s for warnings, 8s for others
                verticalPosition: 'bottom',
                horizontalPosition: 'right',
                fullwidth: false
            }
        );
    }
}
